import InstrumentLookup from 'st-common/Transactions/Models/InstrumentLookup';
import CurrencyLookup from 'st-common/Transactions/Models/CurrencyLookup';

export default class FutureAmounts {

    constructor(
        public currency: CurrencyLookup,
        public yearPlus1Label: string,
        public yearPlus2Label: string,
        public yearPlus3Label: string
    ) {

    }

    // Gross value at award date values
    public grossValueAtAwardDateVestedValue: number = 0;
    public grossValueAtAwardDateYearPlus1Value: number = 0;
    public grossValueAtAwardDateYearPlus2Value: number = 0;
    public grossValueAtAwardDateYearPlus3Value: number = 0;
    public grossValueAtAwardDateAllTimeValue: number = 0;

    // Percentage value growth
    public vestedGrowthPercentage: number = 0;
    public yearPlus1GrowthPercentage: number = 0;
    public yearPlus2GrowthPercentage: number = 0;
    public yearPlus3GrowthPercentage: number = 0;
    public allTimeGrowthPercentage: number = 0;
    
    public vestedValue: number = 0;
    public yearPlus1Value: number = 0;
    public yearPlus2Value: number = 0;
    public yearPlus3Value: number = 0;
    public allTimeValue: number = 0;

    public vestedValue2: number = 0;
    public yearPlus1Value2: number = 0;
    public yearPlus2Value2: number = 0;
    public yearPlus3Value2: number = 0;
    public allTimeValue2: number = 0;

    public year1Boundary: Date | null = null;
    public year2Boundary: Date | null = null;

    public get hasDifferences() {
        return Math.abs(this.vestedValue - this.vestedValue2) > 1
            || Math.abs(this.yearPlus1Value - this.yearPlus1Value2) > 1
            || Math.abs(this.yearPlus2Value - this.yearPlus2Value2) > 1
            || Math.abs(this.yearPlus3Value - this.yearPlus3Value2) > 1
            || Math.abs(this.allTimeValue - this.allTimeValue2) > 1;
    }
}

export interface IFutureAmountInput {
    isVested: boolean;
    canTradeDate: Date;
    instrument: InstrumentLookup;
    marketPriceAtAwardDate: number | null;
    awardedUnits: number;
}